export default function Timeline() {
  const milestones = [
    {
      year: '2024',
      title: 'Foundation',
      description: 'Kagesi Development founded in Zimbabwe with a mission to transform Africa\'s wastewater challenges into circular infrastructure opportunities.',
      icon: 'ri-flag-line',
      color: 'emerald'
    },
    {
      year: '2025',
      title: 'Rapid Acceleration',
      description: 'Launched prefeasibility studies, investor engagement processes, EPC partnerships, and venture-building initiatives across the SADC region.',
      icon: 'ri-rocket-line',
      color: 'amber'
    },
    {
      year: 'Ongoing',
      title: 'Project Pipeline Development',
      description: 'Advancing multiple wastewater-to-value projects across Zimbabwe and Botswana, with active capital raising and strategic partnerships.',
      icon: 'ri-line-chart-line',
      color: 'blue'
    },
    {
      year: 'Future',
      title: 'Regional Expansion',
      description: 'Scaling circular infrastructure solutions across SADC markets, creating a new generation of climate-positive infrastructure in Africa.',
      icon: 'ri-global-line',
      color: 'green'
    }
  ];

  return (
    <section id="timeline" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Our Journey
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Building Africa's <strong>Circular Infrastructure Future</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            From foundation to regional expansion, Kagesi Development is rapidly advancing the circular economy across Southern Africa.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-emerald-200 via-amber-200 to-blue-200"></div>
          
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div 
                key={index} 
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } flex-col lg:flex`}
              >
                <div className={`lg:w-5/12 ${index % 2 === 0 ? 'lg:text-right lg:pr-12' : 'lg:text-left lg:pl-12'}`}>
                  <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-lg hover:shadow-xl transition-all">
                    <div className={`inline-flex items-center gap-2 bg-${milestone.color}-100 text-${milestone.color}-700 px-3 py-1 rounded-full text-sm font-semibold mb-4`}>
                      <i className={milestone.icon}></i>
                      <span>{milestone.year}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{milestone.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{milestone.description}</p>
                  </div>
                </div>
                
                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 bg-white border-4 border-gray-200 rounded-full items-center justify-center z-10">
                  <div className={`w-8 h-8 bg-${milestone.color}-600 rounded-full flex items-center justify-center`}>
                    <i className={`${milestone.icon} text-white text-lg`}></i>
                  </div>
                </div>
                
                <div className="lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}